module.exports = __webpack_public_path__ + "images/hedge-fund-e3109c.png";